<template>
  <basic-container>
    <h3>交易账单</h3>
    <avue-form :option="option" v-model="form" @submit="submit"> </avue-form>
  </basic-container>
</template>

<script>
import { getDownloadBill } from '@/api/v4ward/pay/paytradeall';
var DIC = {
  SETTLEMENTFLAG: [
    {
      label: '交易(未结算+已结算)',
      value: null,
    },
    {
      label: '交易(已结算)',
      value: 2,
    },
  ],
  TRADETYPE: [
    {
      label: '全部',
      value: null,
    },
    {
      label: '交易',
      value: 1,
    },
    {
      label: '退款',
      value: 2,
    },
  ],
};

export default {
  data() {
    return {
      form: {},
      option: {
        labelWidth: 180,
        submitText: 'EXCEL导出',
        column: [
          {
            label: '交易结算标识',
            prop: 'settlementFlag',

            type: 'radio',
            dicData: DIC.SETTLEMENTFLAG,
            mock: {
              type: 'dic',
            },
            span: 24,
            rules: [
              {
                required: false,
                message: '请选择交易结算标识',
              },
            ],
          },
          {
            label: '交易类型',
            prop: 'tradeType',
            type: 'radio',
            dicData: DIC.TRADETYPE,
            mock: {
              type: 'dic',
            },
            span: 24,
            rules: [
              {
                required: false,
                message: '请选择交易类型',
              },
            ],
          },
          {
            label: '交易时间',
            prop: 'payOrRefundTime',
            width: 100,
            type: 'datetimerange',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [
              {
                required: true,
                message: '请选择交易时间',
              },
            ],
          },
        ],
      },
    };
  },
  methods: {
    submit(form, done) {
      let values = {
        settlementFlag: form.settlementFlag,
        tradeType: form.tradeType,
        startPayOrRefundTime: form.payOrRefundTime[0],
        endPayOrRefundTime: form.payOrRefundTime[1],
      };

      getDownloadBill(Object.assign({ current: null, size: null }, values)).then(({ data }) => {
        let sourceOriginAmount = data.records;
        // 需要导出的数据，可以动态获取
        import('@/vendor/Export2Excel.js').then((excel) => {
          // 导入js模块
          const tHeader = [
            '支付成功/退款申请时间',
            '平台商户号',
            '特约商户号',
            '平台支付单号',
            '商户订单号',
            '设备号',
            '支付场景',
            '交易类型',
            '平台退款单号',
            '商户退款单号',
            '支付方式',
            '商品名称',
            '订单金额/申请退款金额（元）',
            '买家支付金额/退款执行金额（元）',
          ]; // 导出excel 的标题
          const filterVal = [
            'payOrRefundTime',
            'wpayMchId',
            'wpayMchVipId',
            'wpayNo',
            'mchOrderNo',
            'deviceInfo',
            'paySceneName',
            'tradeTypeName',
            'wpayRefundNo',
            'mchRefundNo',
            'payMethodName',
            'goodsName',
            'tradeFee',
            'settlementTradeFee',
          ]; // 每个标题对应的字段

          const list = (sourceOriginAmount || []).map((item, key) => {
            // 通过 map 方法遍历，组装数据成上面的格式
            return {
              payOrRefundTime: this.dayjs(item.payOrRefundTime).format('YYYY-MM-DD HH:mm:ss'),
              wpayMchId: item.wpayMchId,
              wpayMchVipId: item.wpayMchVipId,
              wpayNo: item.wpayNo,
              mchOrderNo: item.mchOrderNo,
              deviceInfo: item.deviceInfo,
              paySceneName: item.paySceneName,
              tradeTypeName: item.tradeTypeName,
              wpayRefundNo: item.wpayRefundNo,
              mchRefundNo: item.mchRefundNo,
              payMethodName: item.payMethodName,
              goodsName: item.goodsName,
              tradeFee: item.tradeFee,
              settlementTradeFee: item.settlementTradeFee,
            };
          });

          if (list) {
            const data = this.formatJson(filterVal, list); // 生成json数据
            excel.export_json_to_excel({
              // 调用excel方法生成表格
              header: tHeader,
              data,
              filename: '账单报表' + this.dayjs(new Date()).format('YYYYMMDDHHmmss'),
            });
          } else {
            alert('暂无无数据');
          }
          done();
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>

<style></style>
